import { render, staticRenderFns } from "./BecomeService.vue?vue&type=template&id=76ed79f9"
import script from "./BecomeService.vue?vue&type=script&lang=js"
export * from "./BecomeService.vue?vue&type=script&lang=js"
import style0 from "./BecomeService.vue?vue&type=style&index=0&id=76ed79f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports